import * as RecnService from '@services/recn-service'
import {loadJavascriptSrc} from './util'

var mode
var applePayVersion = 0
var paymentTypes = []
var supportedNetworks = []

export default class ApplePay {
  constructor() { }

  init(options) {
    return new Promise(resolve => {
      mode = options.mode
      paymentTypes = options.paymentTypes

      if (options.paymentTypes.indexOf('Digital') < 0) {
        log.info('Digital Payments not an accepted payment type so Apple Pay is disabled')
        resolve()
        return
      }

      loadJavascriptSrc(process.env.APPLEPAY_SDK)
        .then(() => {
          log.info('Apple Pay SDK loaded')

          if ( !this.isSupported() ) {
            log.info('Apple Pay not supported')
            resolve()
            return
          }

          this.initializeApplePay()
            .then(() => {
              resolve()
              return
            })
        })
        .catch(error => {
          log.error('Error loading Apple Pay SDK', error)
        })
    })
  }

  isOnSupportedDevice() {
    return (window.ApplePaySession ? true : false)
  }

  isSupported() {
    if (this.isOnSupportedDevice()) {
      try {
        return window.ApplePaySession.canMakePayments()
      } catch (e) {
        //Exception can happen if page is iframed
        return false
      }
    }
  }

  initializeApplePay() {
    return new Promise(resolve => {
      //Check if domain has been validated
      RecnService.applePayValidateMerchant(mode)
        .then(() => {
          //Need to convert to Apple's format for card types
          supportedNetworks = []
          paymentTypes.forEach(paymentType => {
            var supportedNetwork

            switch(paymentType) {
            case 'Visa':
              supportedNetwork = 'visa'
              break
            case 'Master Card':
              supportedNetwork = 'masterCard'
              break
            case 'Discover':
              supportedNetwork = 'discover'
              break
            case 'American Express':
              supportedNetwork = 'amex'
              break
            }

            if (supportedNetwork) {
              supportedNetworks.push(supportedNetwork)
            }
          })

          //Set highest supported version
          applePayVersion = 1
          if (!window.ApplePaySession.supportsVersion(-1)) {
            while (window.ApplePaySession.supportsVersion(applePayVersion + 1)) {
              ++applePayVersion
            }
            log.info('Apple Pay version', applePayVersion)
          }
        })
        .catch((e) => {
          log.info('Domain not validated so Apple Pay is disabled', e)
        })
        .finally(() => {
          resolve()
        })
    })
  }

  isActive() {
    return supportedNetworks.length > 0
  }

  createSession(amount, displayName) {
    return new Promise((resolve, reject) => {
      if ( !this.isActive() ) {
        log.error('Apple Pay not active')
        reject('Apple Pay not active')
        return
      }

      // Define ApplePayPaymentRequest
      const request = {
        'countryCode': 'US',
        'currencyCode': 'USD',
        'merchantCapabilities': [
          'supports3DS',
          'supportsCredit',
          'supportsDebit'
        ],
        'supportedNetworks': supportedNetworks,
        'total': {
          'label': displayName || '',
          'type': 'final',
          'amount': amount
        }
      }

      // Create ApplePaySession
      const session = new window.ApplePaySession(applePayVersion, request)

      session.onvalidatemerchant = async () => {
        try {
          const merchantSession = await RecnService.applePayValidateMerchant(mode, displayName)
          session.completeMerchantValidation(merchantSession)
        } catch (e) {
          log.error('applePayValidateMerchant() Error', e.message)
          session.abort()

          reject('error')
        }
      }

      var response

      session.onpaymentauthorized = event => {
        try {
          const result = {
            'status': window.ApplePaySession.STATUS_SUCCESS
          }
          //Complete the Apple Pay session
          session.completePayment(result)

          response = {
            cardInfo: {
              paymentType: toNarPaymentType(event.payment.token.paymentMethod.network),
              displayName: event.payment.token.paymentMethod.displayName
            },
            applePayToken: btoa(JSON.stringify(event.payment.token.paymentData)),
            tokenInfo: btoa(JSON.stringify(event.payment.token.paymentMethod))
          }

          resolve(response)
        } catch (e) {
          log.error('onpaymentauthorized() Error', e.message)

          reject('error')
        }
      }

      session.oncancel = () => {
        reject('cancelled')
      }

      session.begin()
    })
  }
}

/***********************/
/** Private Functions **/
/***********************/

function toNarPaymentType(type) {
  switch (type) {
  case 'MasterCard':
    return 'Master Card'
  case 'AmEx':
    return 'American Express'
  }

  return type
}
